





import { defineComponent } from 'vue';
import { useWeeklyOverview, type WeeklyOverviewActivity } from '../../composables/presence/useWeeklyOverview';

export default defineComponent({
  props: {
    activity: {
      type: Object as () => WeeklyOverviewActivity,
      required: true,
    },
  },
  setup(props) {
    const { blockedLabel } = useWeeklyOverview(props.activity);

    return {
      label: blockedLabel,
    };
  },
});
